import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LinkedCourse } from '../models/linkedCourse';
import { ApiConstants } from '../constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class TrainingCommonService {

  constructor(private httpClient:HttpClient) { }

  getCourseWithListOfCourseNumbers(courseNumbers : string[]): Observable<LinkedCourse[]>{
    return this.httpClient.post<LinkedCourse[]>(ApiConstants.Course_GetCoursesByListOfCourseNumbers, courseNumbers);
  }
}
